module.exports = __webpack_public_path__ + "static/media/attach-file.314bcbd1.svg";